import React from "react";

interface Props {
  onClick: () => void
  style?: React.CSSProperties
}

const TextLinkButton = (props: React.PropsWithChildren<Props>) => {
  return <button className="button-new text" type="button" onClick={props.onClick} style={props.style}>
    {props.children}
  </button>;
};

export default TextLinkButton;